<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>panorama</md-icon>
          </div>
          <h4 class="title">Create New Banner</h4>
        </md-card-header>

        <md-card-content>
          <md-field>
            <label>Title</label>
            <md-input v-model="title" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Description</label>
            <md-input v-model="description" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Button Text</label>
            <md-input v-model="buttonText" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Button Redirection Link</label>
            <md-input v-model="redirectLink" type="text"></md-input>
          </md-field>
          <md-field>
            <input type="file" @change="fileUpload( $event )"  /> 
          </md-field>
        </md-card-content>

        <md-card-actions md-alignment="left">
          <md-button class="md-success" :disabled="isDisabled" @click="createBanner()">
            Create <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>
<script>
import BannerService from "../../services/BannerService";
export default {
  components: {},
  data() {
    return {
      clientId: this.$route.query.id,
      isDisabled: false,
      title: "",
      description:"",
      buttonText:"",
      redirectLink: "",
      bannerimage:"",
    };
  },
  methods: {
    fileUpload(event){
      this.bannerimage = event.target.files[0];
    },
    async createBanner() {
      this.isDisabled = true;
      let formData = new FormData();
      formData.append("bannerimage", this.bannerimage);
      formData.append("title", this.title);
      formData.append("description", this.description);
      formData.append("buttonText", this.buttonText);
      formData.append("redirectLink", this.redirectLink);
      await BannerService.createBanner(formData)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.$router.push('banners');
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
  },
  beforeMount() {
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-inline-checkboxes {
  display: inline-flex;

  .md-checkbox {
    margin-top: 15px !important;
  }
}

.md-checkbox,
.md-radio {
  margin-top: 15px;
  margin-bottom: 0.5rem;
}

.md-checkbox,
.md-radio {
  display: flex;
}

.md-radio .md-radio-container {
  margin-left: 5px;
  position: relative;
  left: -3px;
}

.md-form-label + .md-layout-item .md-checkbox:not(:first-child),
.md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
.md-form-label + .md-layout-item .md-radio {
  margin-top: 0;
}

.form-control-static {
  margin-top: 6px;
}
</style>
